import { createContext, useContext } from 'react';

import type { BadgeArrangement, BadgeEnds } from './Badge';

export type BadgeContextValue = {
  arrangement?: BadgeArrangement;
  ends?: BadgeEnds;
};

const BadgeContext = createContext<BadgeContextValue | undefined>(undefined);
export const BadgeProvider = BadgeContext.Provider;

export const useBadgeArrangement = (
  controlledArrangement?: BadgeArrangement,
  defaultArrangement: BadgeArrangement = 'leading-label',
) => {
  const context = useContext(BadgeContext);
  return controlledArrangement ?? context?.arrangement ?? defaultArrangement;
};

export const useBadgeEnds = (controlledEnds?: BadgeEnds, defaultEnds: BadgeEnds = 'pill') => {
  const context = useContext(BadgeContext);
  return controlledEnds ?? context?.ends ?? defaultEnds;
};
